import axios from "axios";
import { toast } from "react-toastify";
import store from "../store";
import { logout } from "../Features/User/User";

// Global response interceptor — catches 401/403 from all axios calls
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    // An expired/invalid JWT comes back as 401 from the auth middlewares, but the
    // checkAdminOrRoleN admin middlewares return 403 "Invalid token." instead.
    // Treat BOTH as a session expiry so the user is sent to re-login rather than
    // shown a raw "invalid token" error. A genuine permission denial
    // ("Insufficient permissions") or the privileged cost gate ("Forbidden")
    // does NOT match, so those users are not logged out.
    const isInvalidToken = /invalid[_ ]?token/i.test(String(message || ""));
    if (status === 401 || (status === 403 && isInvalidToken)) {
      // Token expired or invalid — sign out the user
      const isAdmin = window.location.pathname.startsWith("/admin");

      if (isAdmin) {
        // Admin token expired
        localStorage.removeItem("tdc_admin_token");
        localStorage.removeItem("tdc_admin_role");
        toast.info("Your admin session has expired. Please sign in again.");
        window.location.href = "/admin/login";
      } else {
        // Customer/retailer token expired
        store.dispatch(logout());
        clearRetailerCache();
        if (message === "token_expired" || message === "invalid_token") {
          toast.info("Your session has expired. Please sign in again.");
        }
      }
    }

    if (status === 403 && message === "blocked") {
      // User has been blocked — force sign out immediately
      const isAdmin = window.location.pathname.startsWith("/admin");

      if (!isAdmin) {
        store.dispatch(logout());
        clearRetailerCache();
        toast.error("Your account has been restricted. Please contact us for assistance.");
      }
    }

    return Promise.reject(error);
  }
);

function clearRetailerCache() {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("tdc_retailer_settings");
  localStorage.removeItem("tdc_product_range_menu");
  localStorage.removeItem("tdc_branded_jewellery_menu");
  localStorage.removeItem("tdc_watches_menu");
}

export default axios;
